<script setup lang="ts">
  import { useSupplierList } from '@/models/supplier'

  defineProps<{
    error?: string | string[],
    required?: boolean,
  }>()

  const modelValue = defineModel<number>({ required: true })

  const { suppliers, loading, getData } = useSupplierList()
  getData()
</script>

<template>
  <app-select
    v-model="modelValue"
    label="Pilih Supplier"
    :loading="loading"
    :required="required"
    :error="error">
    <option :value="0">
      - Pilih Supplier -
    </option>
    <option
      v-for="supplier in suppliers"
      :key="supplier.id"
      :value="supplier.id">
      {{ supplier.name }}
    </option>
  </app-select>
</template>
